<!--
limit: [类型, 长度, 默认值]
设置默认值时，保证 v-model 也有默认值
 <v-input
    v-model="num"
    :limit="['number', 2, 0]"
    size="small"
  ></v-input>
-->
<!--
<template>
  <div style="display: inline-block;">
    <input
      ref="input"
      :value="value"
      :placeholder="placeholder"
      @blur="onBlur($event.target)"
      @input="updateValue($event.target)"
      :class="sizeCls"/>
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: function () {
          return ''
        }
      },
      placeholder: {
        type: String,
        default: function () {
          return ''
        }
      },
      limit: Array,
      size: String
    },
    watch: {},
    computed: {
      sizeCls () {
        if (this.size) {
          if (this.size === 'large') return 'el-input__inner large'
          if (this.size === 'small') return 'el-input__inner small'
          if (this.size === 'mini') return 'el-input__inner mini'
        } else {
          return 'el-input__inner'
        }
      },
      defaultVal () {
        if (this.limit && this.limit[2] !== undefined) {
          return this.limit[2] + ''
        } else return null
      }
    },
    mounted () {
      this.setDefaultVal(this.$refs.input)
    },
    methods: {
      onBlur (target) {
        this.setDefaultVal(target)
      },
      updateValue (target) {
        let value = target.value
        let newVal = this.filterValue(value)
        if (newVal !== value) target.value = newVal
        this.$emit('input', newVal)
      },
      setDefaultVal (target) {
        let newVal = this.filterValue(this.value)
        // 默认值，如果为空则显示默认值
        if (this.defaultVal) {
          if (newVal === null || newVal === '' || newVal === undefined || newVal === this.defaultVal) {
            target.value = this.defaultVal
            this.$emit('input', this.defaultVal)
          }
        }
      },
      filterValue (value) {
        let newVal = value

        if (newVal && this.limit && this.limit.length !== 0) {
          // 类型限制
          if (this.limit[0] === 'number') newVal = newVal.replace(/[^\d]/g, '')
          if (this.limit[0] === 'text') {}

          // 长度限制
          if (this.limit[1]) newVal = newVal.substring(0, this.limit[1])
        }
        return newVal
      }
    }
  }
</script>

<style scoped rel="stylesheet">
  .large {
    height: 42px;
    font-size: 16px;
  }

  .small {
    height: 30px;
    font-size: 13px;
  }

  .mini {
    height: 22px;
    font-size: 12px;
  }

</style>
-->

<template>
  <div style="display: inline-block;" :class="disabledCls">
    <input
      ref="input"
      :disabled="disabled"
      :value="value"
      :placeholder="placeholder"
      @blur="onBlur($event.target)"
      @input="updateValue($event.target)"
      :class="sizeCls"/>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: function () {
          return ''
        }
      },
      placeholder: {
        type: String,
        default: function () {
          return ''
        }
      },
      limit: Array,
      size: String,
      disabled: Boolean
    },
    watch: {},
    computed: {
      disabledCls () {
        if (this.disabled) return 'el-input is-disabled'
        else return ''
      },
      sizeCls () {
        if (this.size) {
          if (this.size === 'large') return 'el-input__inner large'
          if (this.size === 'small') return 'el-input__inner small'
          if (this.size === 'mini') return 'el-input__inner mini'
        } else {
          return 'el-input__inner'
        }
      },
      defaultVal () {
        if (this.limit && this.limit[2] !== undefined) {
          return this.limit[2] + ''
        } else return null
      }
    },
    mounted () {
      this.setDefaultVal(this.$refs.input)
    },
    methods: {
      onBlur (target) {
        this.setDefaultVal(target)
      },
      updateValue (target) {
        let value = target.value
        let newVal = this.filterValue(value)
        if (newVal !== value) target.value = newVal
        this.$emit('input', newVal)
      },
      setDefaultVal (target) {
        let newVal = this.filterValue(this.value)
        // 默认值，如果为空则显示默认值
        if (this.defaultVal) {
          if (newVal === null || newVal === '' || newVal === undefined || newVal === this.defaultVal) {
            target.value = this.defaultVal
            this.$emit('input', this.defaultVal)
          }
        }
      },
      filterValue (value) {
        let newVal = value

        if (newVal && this.limit && this.limit.length !== 0) {
          // 类型限制
          if (this.limit[0] === 'count') {
            newVal = newVal.replace(/[^\d]/g, '')
            newVal = parseInt(newVal)
            if (newVal <= this.limit[1]) return newVal
            else return this.limit[1]
          } else if (this.limit[0] === 'number') {
            newVal = newVal.replace(/[^\d]/g, '')
          } else if (this.limit[0] === 'text') {}

          // 长度限制
          if (this.limit[1]) newVal = newVal.substring(0, this.limit[1])
        }
        return newVal
      }
    }
  }
</script>

<style scoped rel="stylesheet">
  .large {
    height: 42px;
    font-size: 16px;
  }

  .small {
    height: 30px;
    font-size: 13px;
  }

  .mini {
    height: 22px;
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// vInput.vue?53aae900